<div
  class="flex flex-col items-start rounded-[0.5rem] w-full bg-white gap-[1.5rem]">
  <!-- Default Upload - hide in view/disabled mode -->
  <label *ngIf="variant === 'default' && !disabled"
    [for]="id"
    class="inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-white bg-blue-500 rounded-md cursor-pointer transition duration-300 ease-in-out"
    [ngClass]="{
      'opacity-50 cursor-not-allowed': disabled,
      'hover:bg-primary-500': !disabled
    }">
    <span class="font-archivo">{{ label }}</span>
    <input #fileInput type="file" [id]="id" [accept]="fileTypes" [multiple]="multiSelect" [disabled]="disabled" class="hidden"
      (change)="handleChange($event)" />
  </label>

  <!-- Drag & Drop Upload -->

  <div *ngIf="variant === 'drag and drop'" class="w-full flex flex-col items-center justify-center">
    <div class="w-full flex flex-row items-center justify-start">
      <label *ngIf="label"
        [for]="id"
        class="block text-gray-1400 leading-[1.813rem] lg:text-[1.125rem] md:text-[1.125rem] sm:text-[1.125rem] xs:text-[1.125rem] text-[1rem]  font-bold font-archivo">{{title}}
        <span *ngIf="required" class ="text-danger-500">*</span></label>
    </div>

    <div class="w-full flex flex-col items-start justify-center gap-[0.25rem]">
      <span *ngIf="hint && !disabled" class="leading-[1.813rem] lg:text-[1.125rem] md:text-[1.125rem] sm:text-[1.125rem] xs:text-[1.125rem] text-[1rem] font-normal font-archivo text-gray-1200">{{ hint
        }}</span>

      <!-- Upload input area - hide when hideUploadArea (view mode); when disabled in edit mode, show grayed out -->
      <div *ngIf="!hideUploadArea"
        class="flex flex-col items-center gap-[1rem] justify-center w-full border-[1px] border-dashed rounded-md transition duration-300 ease-in-out p-[1.5rem]"
        [ngClass]="{
      'opacity-50 cursor-not-allowed pointer-events-none': disabled,
      'cursor-pointer': !disabled,
      'border-primary-500': dragActive && !hasError && !disabled,
      'border-danger-500': hasError,
      'border-gray-1300': !dragActive && !hasError,
      'hover:border-primary-500': !disabled && !dragActive && !hasError
    }" (click)="!disabled && triggerFileDialog()" (keydown.enter)="!disabled && triggerFileDialog()" (dragenter)="!disabled && handleDrag($event)" (dragover)="!disabled && handleDrag($event)"
        (dragleave)="!disabled && handleDrag($event)" (drop)="!disabled && handleDrop($event)">

        <NiFormIcon icon="fileUpload" iconClass="!w-[2.5rem] !h-[2.5rem] " />
        <span class="text-primary-500 text-[1.125rem] text-center underline font-archivo">{{ label }}</span>
        <span class="text-black opacity-[60%] text-[1rem] text-center font-archivo">{{ getFileTypesDisplay() }}</span>

        <input #fileInput type="file" [id]="id" [accept]="fileTypes" [multiple]="multiSelect" [disabled]="disabled" class="hidden"
          (change)="handleChange($event)" />
      </div>
      
      <!-- Error Message -->
      <span *ngIf="hasError && errorMessage" class="text-danger-500 text-sm font-archivo mt-1">
        {{ errorMessage }}
      </span>
    </div>
  </div>
  <!-- Info + Hint - hide in view/disabled mode -->
  <span *ngIf="variant === 'default' && !disabled" class="text-gray-1200 text-[14px] mt-1 font-archivo">
    {{ getFileTypesDisplay() }}
  </span>
  <span *ngIf="variant === 'default' && !disabled && hint" class="text-[14px] mt-1 font-archivo">{{ hint }}</span>

  <!-- Pending Files List (files selected but not yet uploaded) -->
  <div *ngIf="files.length > 0 && disableAutoUpload" class="flex flex-col items-start w-full gap-[1.5rem]">
    <div *ngFor="let file of files; let i = index"
      class="flex items-center justify-between w-full border border-gray-600 rounded-lg px-4 py-3 shadow-sm transition">
      <div class="flex items-center gap-3 w-full">
        <div class="flex items-center justify-center w-[2.5rem] h-[2.5rem] flex-shrink-0">
          <!-- Show icon for all file types -->
          <NiFormIcon [icon]="getFileIcon(file)" 
                  iconClass="!w-[2.5rem] !h-[2.5rem]" />
        </div>
        <div class="flex flex-col truncate w-full">
          <span class="text-black opacity-88 font-normal leading-[32px] text-[18px] truncate font-archivo">
            {{ file.name }}
          </span>
          <span class="text-gray-1200 leading-[23px] text-[16px] font-archivo">
            {{ formatBytes(file.size) }} • Pending upload
          </span>
        </div>
      </div>
      <div *ngIf="!disabled" class="cursor-pointer text-gray-1200 hover:text-red-500 transition ml-3" (click)="handleRemoveFile(i)" (keydown.enter)="handleRemoveFile(i)">
        <NiFormIcon icon="delete" iconClass="!w-[1.25rem] !h-[1.25rem]" />
      </div>
    </div>
  </div>

  <!-- Uploaded Files List -->
<!-- Uploaded Files List -->
<div *ngIf="uploadedFiles.length > 0" class="flex flex-col items-start w-full gap-[1.5rem]">

  <div *ngFor="let uploadedFile of uploadedFiles; let i = index"
       class="flex items-center justify-between w-full border border-gray-600 rounded-lg px-4 py-3 shadow-sm transition">

    <!-- LEFT SECTION (icon + text) -->
    <div class="flex items-center gap-3 w-full min-w-0">

      <!-- FILE ICON -->
      <div class="flex-shrink-0 flex items-center justify-center w-[2.5rem] h-[2.5rem]">
        <!-- Show icon for all file types -->
        <NiFormIcon [icon]="getFileIcon(uploadedFile.file)" 
                iconClass="!w-[2.5rem] !h-[2.5rem]" />
      </div>

      <!-- FILE TEXT -->
      <div class="flex flex-col min-w-0 flex-1 truncate gap-2">

        <span class="text-black opacity-88 font-normal leading-[32px] lg:text-[1.125rem] md:text-[1.125rem] sm:text-[1.125rem] xs:text-[1.125rem] text-[1rem] truncate font-archivo">
          {{ uploadedFile.file.name }}
        </span>

        <span class="text-gray-1200 leading-[23px] text-[16px] font-archivo"
              *ngIf="uploadedFile.uploading">
          {{ formatBytes(uploadedFile.file.size) }} • Uploading...
        </span>

        <span class="text-gray-1200 leading-[23px] text-[16px] font-archivo"
              *ngIf="!uploadedFile.uploading && uploadedFile.key">
          {{ formatBytes(uploadedFile.file.size) }} • Uploaded successfully
        </span>

        <span class="text-red-600 text-[16px] font-archivo"
              *ngIf="uploadedFile.error">
          {{ formatBytes(uploadedFile.file.size) }} • Error: {{ uploadedFile.error }}
        </span>

      </div>
    </div>

    <!-- View (staff review) + Remove (edit) -->
    <div class="flex-shrink-0 flex flex-row items-center gap-2 ml-3">
      <button
        *ngIf="canAccessUploadedFile(uploadedFile)"
        type="button"
        class="cursor-pointer text-gray-1200 hover:text-primary-500 transition p-1 disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="isAccessingUploadedFile(uploadedFile)"
        (click)="handleViewUploadedFile(uploadedFile)"
        aria-label="View file"
        title="View"
      >
        <NiFormIcon icon="eye" iconClass="!w-[1.25rem] !h-[1.25rem]" />
      </button>
      <div
        *ngIf="!disabled && uploadedFile.key && !uploadedFile.uploading"
        class="cursor-pointer text-gray-1200 hover:text-red-500 transition"
        (click)="handleRemoveUploadedFile(uploadedFile.key!)"
        (keydown.enter)="handleRemoveUploadedFile(uploadedFile.key!)"
        role="button"
        tabindex="0"
        aria-label="Remove uploaded file"
      >
        <NiFormIcon icon="delete" iconClass="!w-[1.25rem] !h-[1.25rem]" />
      </div>
    </div>

  </div>

</div>


    @if (showToaster) {
    <NiFormToaster [message]="toasterMessage" [type]="toasterType" (onClose)="closeToaster()" position="bottom-center">
    </NiFormToaster>
    }

</div>
  <div class="flex items-end justify-between min-h-[25px]">
  </div>

